import { render, staticRenderFns } from "./riskPointHazardSource.vue?vue&type=template&id=a7c9fb3a&scoped=true&"
import script from "./riskPointHazardSource.vue?vue&type=script&lang=ts&"
export * from "./riskPointHazardSource.vue?vue&type=script&lang=ts&"
import style0 from "./riskPointHazardSource.vue?vue&type=style&index=0&id=a7c9fb3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7c9fb3a",
  null
  
)

export default component.exports